// Local-only CARTO Basemaps API key. This file is gitignored — never commit
// a real key here. Get a free key at https://carto.com/basemaps/apikey and
// paste it below.
export const CARTO_API_KEY = 'cb1_2kpu_1_a1b567f45d3484caeef161dd';
